import DesktopMap from './desktopMap/DesktopMap';
import MobileMap from './mobileMap/MobileMap';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import useDevice from '@/hooks/useDevice';
import { ProductListRecord } from '@/components/reusable/productCard/types';
interface MapSectionProps {
  data: ProductListRecord[];
  loading: boolean;
  setMapFullscreen: Dispatch<SetStateAction<boolean>>;
  mapFullscreen: boolean;
  isTehran: boolean;
}
const MapSection = ({
  data,
  loading,
  setMapFullscreen,
  mapFullscreen,
  isTehran
}: MapSectionProps) => {
  const [invalidateMapSize, setInvalidateMapSize] = useState(false);
  const {
    isMobile
  } = useDevice();
  useEffect(() => {
    const invalidateMapSize = setTimeout(() => {
      setInvalidateMapSize(true);
    }, 1000);
    return () => {
      clearTimeout(invalidateMapSize);
    };
  }, []);
  return <>
      {!!invalidateMapSize && (isMobile ? <MobileMap data={data} loading={loading} isTehran={isTehran} /> : <DesktopMap data={data} loading={loading} setMapFullscreen={setMapFullscreen} mapFullscreen={mapFullscreen} />)}
    </>;
};
export default MapSection;